import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
import { CheckoutButton } from '../CheckoutButton';
const tryItems = ['Explore the modules', 'Use the visual maps', 'Try the checklists', 'Run the 15-minute reviews', 'Use the flashcards'];
export function GuaranteeSection() {
  return <section className="bg-white px-4 py-14 sm:py-20" data-id="element-172" data-mp="1fdaon8aq813q">
      <div className="mx-auto w-full max-w-2xl" data-id="element-173" data-mp="1faojtgf7zzp7">
        <div className="rounded-3xl border-2 border-aqua-500/30 bg-aqua-50 p-6 text-center sm:p-9" data-id="element-174" data-mp="1ady3qt3f143s">
          <div className="mx-auto flex h-16 w-16 items-center justify-center rounded-2xl bg-navy-900" data-id="element-175" data-mp="15ebpqhfrjjtx">
            <ShieldCheckIcon className="h-8 w-8 text-aqua-400" aria-hidden="true" data-id="element-176" data-mp="11e1byilqbp4i" />
          </div>
          <h2 className="mt-5 font-display text-[26px] font-bold leading-tight tracking-tight text-navy-900 sm:text-4xl" data-id="element-177" data-mp="weyilvf437cd">
            7-Day money-back guarantee
          </h2>
          <p className="mt-3 text-[15px] text-navy-800/75 sm:text-lg" data-id="element-178" data-mp="2qrek6iwypxaw">
            Try PROSTHO 360™ completely risk-free.
          </p>

          <ul className="mx-auto mt-6 grid max-w-md gap-2 text-left sm:grid-cols-2" data-id="element-179" data-mp="1g422w6fudx77">
            {tryItems.map(item => <li key={item} className="rounded-xl bg-white px-3.5 py-2.5 text-[13.5px] font-semibold text-navy-800 ring-1 ring-navy-800/8" data-id="element-180" data-mp="1l1txx9bs9zfm">
                {item}
              </li>)}
          </ul>

          <p className="mt-6 text-[15px] leading-relaxed text-navy-800/75" data-id="element-181" data-mp="1ztvtwiaqg8ad">
            If within 7 days you decide PROSTHO 360™ isn't a good fit for the way you study,{' '}
            <strong className="font-extrabold text-navy-900" data-id="element-182" data-mp="1q3jaitenml5t">you'll get a 100% refund.</strong> No complicated
            process. No long explanation. Simply contact us within the guarantee period.
          </p>

          <div className="mt-7" data-id="element-183" data-mp="2irf25jpd9mvq">
            <CheckoutButton label="Try Prostho 360™ risk-free" sub="7 days to decide · Full refund" data-id="element-184" data-mp="2iqds9ik376fl" />
          </div>
        </div>
      </div>
    </section>;
}